module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_rushing_tds/blue-b2ab9fd01a969da1146b1594801871c9.svg";